import Icon from "../Icon";
import { WHY } from "../../data";
import { Reveal } from "../Reveal";

export default function WhyGrid() {
  return (
    <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
      {WHY.map((w, i) => (
        <Reveal key={w.title} delay={i * 0.05}>
          <div
            className="flex items-center gap-4 rounded-2xl border border-white/10 bg-white/[0.03] p-6 backdrop-blur-xl transition-colors duration-300 hover:border-white/20"
            data-testid={`why-card-${i}`}
          >
            <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-blue-600/15 text-blue-400">
              <Icon name={w.icon} className="h-5 w-5" />
            </div>
            <p className="font-medium text-white">{w.title}</p>
          </div>
        </Reveal>
      ))}
    </div>
  );
}
